/**
 * Content Tab Section Interactive Script
 * - Handles accordion expand/collapse
 * - Preserves bottom item always open ("niche wali always open rhegi")
 * - Single-open behavior for non-bottom items (opening one closes previous)
 * - Shopify theme customizer live preview integration
 */

(function () {
  'use strict';

  function initContentTabSection(section) {
    if (!section || section.dataset.contentTabInit === 'true') return;
    section.dataset.contentTabInit = 'true';

    const items = Array.from(section.querySelectorAll('.content-tab__item'));
    if (!items.length) return;

    // Identify the last item as permanent
    const lastItem = items[items.length - 1];
    if (lastItem) {
      lastItem.classList.add('is-permanent');
      lastItem.classList.add('is-open');
      const lastHeader = lastItem.querySelector('.content-tab__header');
      if (lastHeader) {
        lastHeader.setAttribute('aria-expanded', 'true');
      }
    }

    function openItem(item) {
      if (!item) return;
      item.classList.add('is-open');
      const header = item.querySelector('.content-tab__header');
      if (header) {
        header.setAttribute('aria-expanded', 'true');
      }
    }

    function closeItem(item) {
      if (!item) return;
      // Never close permanent item
      if (item.classList.contains('is-permanent')) return;

      item.classList.remove('is-open');
      const header = item.querySelector('.content-tab__header');
      if (header) {
        header.setAttribute('aria-expanded', 'false');
      }
    }

    function toggleItem(item) {
      if (!item) return;

      // Bottom item always stays open
      if (item.classList.contains('is-permanent')) {
        return;
      }

      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        // Close if currently open
        closeItem(item);
      } else {
        // Close all other non-permanent items
        items.forEach((otherItem) => {
          if (otherItem !== item && !otherItem.classList.contains('is-permanent')) {
            closeItem(otherItem);
          }
        });
        // Open clicked item
        openItem(item);
      }
    }

    // Attach click and keyboard events
    items.forEach((item, index) => {
      const header = item.querySelector('.content-tab__header');
      const desktopCard = item.querySelector('.content-tab__media-card--desktop');

      function handleAction(e) {
        // Do not trigger if click originated on an interactive element like an anchor tag or button inside rich text
        if (e.target.closest('a') || e.target.closest('button:not(.content-tab__header)')) {
          return;
        }
        e.preventDefault();
        toggleItem(item);
      }

      if (header) {
        header.addEventListener('click', handleAction);
        header.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleItem(item);
          }
        });
      }

      if (desktopCard) {
        desktopCard.addEventListener('click', handleAction);
      }
    });

    // Support Shopify Theme Customizer block selection
    section.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail?.blockId;
      if (!blockId) return;
      const targetItem = section.querySelector(`[data-block-id="${blockId}"]`);
      if (targetItem && !targetItem.classList.contains('is-permanent')) {
        items.forEach((otherItem) => {
          if (otherItem !== targetItem && !otherItem.classList.contains('is-permanent')) {
            closeItem(otherItem);
          }
        });
        openItem(targetItem);
      }
    });
  }

  function initAll() {
    const sections = document.querySelectorAll('.content-tab-section');
    sections.forEach(initContentTabSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Editor Event Listeners
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.classList.contains('content-tab-section')
      ? event.target
      : event.target.querySelector('.content-tab-section');
    if (section) {
      section.dataset.contentTabInit = 'false';
      initContentTabSection(section);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    const targetBlock = event.target;
    if (!targetBlock) return;
    const section = targetBlock.closest('.content-tab-section');
    if (section) {
      const blockId = targetBlock.dataset?.blockId || targetBlock.getAttribute('data-block-id') || event.detail?.blockId;
      const item = targetBlock.classList.contains('content-tab__item')
        ? targetBlock
        : targetBlock.querySelector('.content-tab__item') || section.querySelector(`[data-block-id="${blockId}"]`);
      if (item && !item.classList.contains('is-permanent')) {
        const items = Array.from(section.querySelectorAll('.content-tab__item'));
        items.forEach((otherItem) => {
          if (otherItem !== item && !otherItem.classList.contains('is-permanent')) {
            otherItem.classList.remove('is-open');
            const h = otherItem.querySelector('.content-tab__header');
            if (h) h.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.add('is-open');
        const h = item.querySelector('.content-tab__header');
        if (h) h.setAttribute('aria-expanded', 'true');
      }
    }
  });
})();
